import { poll } from 'lib/poll';
import { MutationCreateSoftAmendmentArgs, createSoftAmendment, acceptAmendment } from 'lib/graphql';
import { GraphQLClient } from 'types';
import { millisecond } from 'config/constants';
import { SelfServiceAPI } from 'apis';

export const processSoftAmendment = async (client: GraphQLClient, { bookingId, input }: MutationCreateSoftAmendmentArgs) => {
  const createResult = await createSoftAmendment(client, { variables: { bookingId, input } });
  const amendmentId = createResult.data?.createSoftAmendment.id;

  if (!amendmentId) {
    throw new Error('Failed creating amendment');
  }

  const quotedResult = await poll({
    requestFn: () => SelfServiceAPI.getAmendment({ bookingId, amendmentId }),
    isFinished: (result) => result.amendment.state !== 'QUOTING',
    timeoutMs: millisecond.MINUTE,
  });

  if (quotedResult.amendment.state !== 'QUOTED') {
    throw new Error(`Expected amendment to be "QUOTED" but state was "${quotedResult.amendment.state}"`);
  }

  if (quotedResult.amendment.amendmentTotal?.type !== 'NO_PAYMENT') {
    throw new Error(`Expected non financial amendment`);
  }

  await acceptAmendment(client, { variables: { bookingId, amendmentId } });

  const acceptedResult = await poll({
    requestFn: () => SelfServiceAPI.getAmendment({ bookingId, amendmentId }),
    isFinished: (result) => result.amendment.state !== 'ACCEPTING',
    timeoutMs: millisecond.MINUTE,
  });

  if (acceptedResult.amendment.state !== 'ACCEPTED') {
    throw new Error(`Expected amendment to be "ACCEPTED" but state was "${acceptedResult.amendment.state}"`);
  }

  return acceptedResult.amendment;
};
